import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useTheme } from '@/contexts/ThemeContext';

const CARD_CLASS = 'bg-white dark:bg-[var(--surface)] shadow-card h-full flex flex-col rounded-card';

const BAR_COLORS_LIGHT = [
  '#F3CF5B', '#F3CF5B', '#F3CF5B', '#F3CF5B', '#F3CF5B', '#F3CF5B', '#F3CF5B', '#F3CF5B',
];

export function HorizontalBarCard({ title, data, maxValue, showDots, className = '' }) {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const max = maxValue || Math.max(...data.map(d => d.max || d.value), 1);
  const total = data.reduce((sum, d) => sum + d.value, 0);

  return (
    <Card className={`${CARD_CLASS} ${className}`} data-testid="horizontal-bar-card">
      <CardHeader className="pb-2 pt-5 px-6 shrink-0">
        <CardTitle className="text-xs lg:text-base font-semibold text-gray-800 dark:text-white">{title}</CardTitle>
      </CardHeader>
      <CardContent className="flex-1 px-6 pb-4 pt-1 overflow-auto">
        {data.length === 0 ? (
          <p className="text-gray-400 dark:text-gray-500 text-sm text-center py-8">No data</p>
        ) : (
          <div className="space-y-3">
            {data.map((item, i) => {
              const itemMax = item.max || max;
              const pct = itemMax > 0 ? Math.round((item.value / itemMax) * 100) : 0;
              const totalPct = total > 0 ? Math.round((item.value / total) * 100) : 0;
              const barColor = isDark ? '#ffffff' : (item.color || BAR_COLORS_LIGHT[i % BAR_COLORS_LIGHT.length]);
              const trackColor = isDark ? '#2a2f38' : '#f0f0f3';
              return (
                <div key={item.name} className="flex items-center gap-2.5" data-testid={`bar-row-${i}`}>
                  {showDots && (
                    <div className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: item.color || barColor }} />
                  )}
                  <span className="text-[11px] lg:text-xs font-medium text-gray-600 dark:text-gray-400 w-[80px] truncate shrink-0">
                    {item.name}
                  </span>
                  <div className="flex-1 h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: trackColor }}>
                    <div
                      className="h-full rounded-full transition-all duration-500"
                      style={{ width: `${Math.min(pct, 100)}%`, backgroundColor: barColor }}
                    />
                  </div>
                  <span className="text-[11px] lg:text-xs font-bold text-gray-800 dark:text-white tabular-nums w-[28px] text-right shrink-0">
                    {item.value}
                  </span>
                  <span className="text-[10px] lg:text-[11px] text-gray-400 dark:text-gray-500 tabular-nums w-[30px] text-right shrink-0">
                    {item.max ? pct : totalPct}%
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
